/**
 * Guest personal details helpers (booking form).
 *
 * The `Date of Birth` field is guessed automatically from the guest `age`
 * field; when the user changes the date of birth the age field is updated
 * too (both directions are kept in sync).
 */

/** Date to 'YYYY-MM-DD' (local timezone). */
function toIsoDate(d) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/**
 * Guess a date of birth from the guest age: today's date shifted back
 * by `age` full years. Returns '' when the age is not plausible.
 */
export function dateOfBirthFromAge(age) {
  const a = parseInt(age, 10);
  if (!Number.isFinite(a) || a < 1 || a > 130) return '';
  const today = new Date();
  return toIsoDate(new Date(today.getFullYear() - a, today.getMonth(), today.getDate()));
}

/**
 * Compute the full-year age from a 'YYYY-MM-DD' date of birth.
 * Returns null when the value is missing or not a valid date.
 */
export function ageFromDateOfBirth(dob) {
  if (!dob) return null;
  const b = new Date(dob);
  if (Number.isNaN(b.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - b.getFullYear();
  const monthDiff = today.getMonth() - b.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < b.getDate())) {
    age -= 1;
  }
  return age;
}

/** True when the value is a valid 'YYYY-MM-DD' date. */
export function isValidIsoDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(value ?? ''))) return false;
  const d = new Date(value);
  return !Number.isNaN(d.getTime());
}
